import {
  ChartBarIcon,
} from '@heroicons/react/24/outline'
import { REPORT_ICONS } from "./reports.icons";
import MegaphoneIcon from 'assets/nav-icons/megaphone.svg?react'

import { NAV_TYPE_ITEM, NAV_TYPE_COLLAPSE } from 'constants/app.constant'

const ROOT_REPORTS = '/reports'

export const reports = {
  id: 'reports',
  type: NAV_TYPE_COLLAPSE,
  path: ROOT_REPORTS,
  title: 'Reports',
  transKey: 'Reports',
  Icon: ChartBarIcon,
  permissionCode: "RPTRPTView",
  childs: [
    {
      id: 'lead-reports.lead-source',
      type: NAV_TYPE_ITEM,
      path: '/reports/lead-source',
      title: 'Lead Source Report',
      Icon: MegaphoneIcon,
      permissionCode: "LSRLSRV",
    },
    {
      id: 'lead-reports.lead-allocation',
      type: NAV_TYPE_ITEM,
      path: '/reports/lead-allocation',
      title: 'Lead Allocation',
      Icon: REPORT_ICONS.leadAllocation,
      permissionCode: "LALAV",
    },
    {
      id: 'lead-reports.lead-status',
      type: NAV_TYPE_ITEM,
      path: '/reports/lead-status',
      title: 'Lead Status Report',
      Icon: REPORT_ICONS.leadSource,
      permissionCode: "LSTLSTV",
    },
    // {
    //   id: 'lead-reports.salesperson-performance',
    //   type: NAV_TYPE_ITEM,
    //   path: '/reports/salesperson-performance',
    //   title: 'Salesperson Performance',
    //   Icon: REPORT_ICONS.salespersonPerformance,
    // }, 
  ],
}